import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { ProductSection } from '../components/ProductSection';
import { OfferSection } from '../components/OfferSection';
import { CloseSection } from '../components/CloseSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-midnight text-cream font-body selection:bg-amber selection:text-midnight overflow-x-hidden" data-id="element-219">
      <HeroSection data-id="element-220" />
      <ProblemSection data-id="element-221" />
      <ProductSection data-id="element-222" />
      <OfferSection data-id="element-223" />
      <CloseSection data-id="element-224" />
      <Footer data-id="element-225" />
    </main>;
}